import {useMemo} from "react";
import {useGetCategoriesQuery} from "@/lib/api/games/gameApi";
import {useLobbyCountry} from "@/hooks/use-lobby-country";
import {FALLBACK_LOBBY_CATEGORIES} from "@/lib/utils/contants/lobbyCategories";

// AC-819: the lobby structure (categories, their order and the providers row)
// comes from the backend, resolved for the player's GEO. The legacy hardcoded
// list is only a fallback while loading or when the request fails.
export const useLobbyCategories = () => {
    const country = useLobbyCountry();
    const {data, isLoading} = useGetCategoriesQuery({country});

    const categories = useMemo(
        () => (data?.length ? data : FALLBACK_LOBBY_CATEGORIES),
        [data]);

    return {categories, country, isLoading};
};
